<template>
  <div class="container">
    <!--Section: Content-->
    <section class="formation">
      <!-- Section heading -->
      <h2 class="text-center font-weight-bold">Formations Taxi</h2>
      <!-- Section description -->
      <div class="mx-auto w-responsive">
        <div class="container">
          <!--Section: Content-->
          <section class="text-center">
            <!-- Section heading -->
            <p
              class="text-center argument font-weight-bold dark-grey-text pb-2 my-4"
            >
              <strong>Devenir Taxi</strong>
            </p>
            <!-- Section description -->
            <p class="text-center w-responsive mx-auto mb-5">
              Explorez nos <strong>formations taxi</strong>, élaborées pour vous
              permettre d'acquérir les compétences et les connaissances
              nécessaires à votre carrière.
            </p>

            <ServicePricingCarousel
              eyebrow="Formation taxi"
              :offers="carouselOffers"
            />
            <!-- Grid row -->
          </section>
          <!--Section: Content-->
        </div>
      </div>
      <div class="hr-d"></div>
      <CallToContact
        title="Contactez nous"
        subTitle="L'equipe pédagogique de l'institut taxi s'occupe de vos démarches administratives."
      />
      <!-- Grid row -->
    </section>
    <!--Section: Content-->
  </div>
  <section class="container-fluid double-block">
    <div class="double-block__title">
      <h2><span class="brand-pseudo">ITTI</span><br />Ecole Taxi</h2>
    </div>
    <div class="dark-grey-text double-block__articles">
      <ServiceFeatureBlock
        title="Préparez votre carte professionnelle"
        tone="secondary"
        :copy-html="featureCopy.intro"
      >
        <template #media>
          <img
            src="@/assets/pictures/taxi-paris.webp"
            alt="taxi-car-in-paris"
            class="img-fluid"
            loading="lazy"
          />
        </template>
      </ServiceFeatureBlock>
      <div class="hr-d"></div>
      <ServiceFeatureBlock
        title="Avancez sans bloquer votre activité"
        title-id="nightLesson"
        tone="primary"
        reverse
        :copy-html="featureCopy.evening"
      >
        <template #media>
          <img
            src="@/assets/pictures/sunshine.webp"
            alt="a-sunshine"
            class="img-fluid"
            loading="lazy"
          />
        </template>
      </ServiceFeatureBlock>
    </div>
  </section>
  <HomeEnd section="taxi" />
</template>

<script>
import CallToContact from "@/components/plugins/CallToContact.vue";
import HomeEnd from "../home/HomeEnd.vue";
import ServiceFeatureBlock from "./ServiceFeatureBlock.vue";
import ServicePricingCarousel from "./ServicePricingCarousel.vue";

const featureCopy = {
  intro:
    "L'Institut Taxi propose une <strong>formation taxi</strong> complète pour préparer la <strong>carte professionnelle</strong> dans un cadre sérieux. Vous travaillez la réglementation, la sécurité routière, la gestion des courses, la relation client et les bonnes pratiques du métier. Nos formateurs vous accompagnent jusqu'aux épreuves théoriques et pratiques afin d'aborder l'examen avec méthode. La préparation vise autant la réussite à l'examen que l'entrée dans le métier avec des bases solides. Les parcours restent <strong>éligibles au CPF</strong> et s'appuient sur une progression claire, avec des repères concrets pour comprendre le terrain, le déroulé de l'examen et les attentes réelles de la profession.",
  evening:
    "Nos <strong>cours accélérés</strong> et <strong>cours du soir</strong> permettent d'avancer vers la <strong>carte taxi</strong> sans bloquer votre activité. Le programme va à l'essentiel tout en conservant un suivi pédagogique solide, des horaires plus souples et des solutions de financement adaptées. Le <strong>CPF</strong>, le paiement en plusieurs fois et l'accessibilité du centre aux <strong>personnes à mobilité réduite</strong> facilitent aussi l'entrée en formation. C'est une formule pensée pour avancer plus vite sans perdre en clarté ni en accompagnement. Vous gardez ainsi un rythme compatible avec votre quotidien tout en continuant à préparer sérieusement les modules, l'examen et la prise en main du métier.",
};

const featuredOffers = [
  {
    id: "taxi-initiale-day",
    title: "Initiale",
    badge: "Journée",
    price: "1350",
    fee: "+237€ frais examen CMA",
    route: "/formation-taxi-initiale",
    meta: [
      { label: "Durée", value: "3 semaines" },
      { label: "Rythme", value: "Lundi au vendredi" },
      { label: "Horaires", value: "9h30 / 16h30" },
    ],
    highlights: [
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
  },
  {
    id: "taxi-initiale-evening",
    title: "Initiale",
    badge: "Soir",
    price: "1350",
    fee: "+237€ frais examen CMA",
    route: "/formation-taxi-initiale",
    meta: [
      { label: "Durée", value: "2 semaines" },
      { label: "Rythme", value: "Lundi au vendredi" },
      { label: "Horaires", value: "18h / 22h" },
    ],
    highlights: [
      "Examen blanc inclus",
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
  },
  {
    id: "taxi-initiale-weekend",
    title: "Initiale",
    badge: "Week-end",
    price: "1350",
    fee: "+237€ frais examen CMA",
    route: "/formation-taxi-initiale",
    meta: [
      { label: "Durée", value: "4 week-ends" },
      { label: "Rythme", value: "Samedi et dimanche" },
      { label: "Horaires", value: "9h30 / 16h30" },
    ],
    highlights: [
      "Examen blanc inclus",
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
  },
  {
    id: "taxi-elearning",
    title: "E-learning",
    badge: "En ligne",
    price: "549",
    fee: "Frais d'examen inclus",
    route: "/formation-taxi-en-ligne",
    meta: [
      { label: "Durée", value: "1 mois" },
      { label: "Support", value: "Application ludo-pédagogique" },
      { label: "Questions", value: "Entre 1 000 et 1 500" },
    ],
    highlights: [
      "4 fois 137,25€ sans frais",
      "QCM, jeux, duels, etc.",
      "Théorie et pratique avec véhicule",
      "Examen blanc inclus",
    ],
  },
];

const secondaryOffers = [
  {
    id: "taxi-continue",
    title: "Continue",
    badge: "14h",
    price: "229",
    route: "/formation-taxi-continue",
    meta: [
      { label: "Volume", value: "14h / 2 jours" },
      { label: "Planning", value: "Disponibilité à convenir" },
    ],
    note: {
      title: "A savoir",
      text: "Cette formation continue est obligatoire pour les chauffeurs déjà titulaires de la carte professionnelle taxi. Elle se suit tous les 5 ans pour mettre à jour réglementation, sécurité routière et gestion.",
    },
    highlights: [],
  },
  {
    id: "taxi-pratique-seule",
    title: "Pratique seule",
    badge: "Conduite",
    price: "390",
    route: "/formation-taxi-pratique-seule",
    meta: [
      { label: "Accompagnement", value: "3 séances de conduite" },
      {
        label: "Examen",
        value: "Véhicule mis à disposition le jour de l'examen",
      },
    ],
    note: {
      title: "Pour qui ?",
      text: "Cette formule est pensée pour les candidats qui veulent se concentrer sur l'épreuve pratique taxi. Elle cible la conduite en circulation et la préparation du jour J avec véhicule mis à disposition.",
    },
    highlights: [],
  },
  {
    id: "passerelle-vtc-taxi",
    title: "Passerelle",
    badge: "VTC > Taxi",
    price: "600",
    fee: "+162€ frais examen CMA",
    route: "/formation-mobilite-passerelle-vtc-vers-taxi",
    meta: [
      { label: "Volume", value: "5 jours" },
      { label: "Planning", value: "Disponibilités à convenir" },
    ],
    note: {
      title: "Transition",
      text: "Cette formule prépare la conversion vers l'activité taxi avec un focus sur la réglementation, la gestion de l'activité et les spécificités du terrain.",
    },
    highlights: ["Véhicule mis à disposition le jour de l'examen"],
  },
  {
    id: "passerelle-taxi-vtc",
    title: "Passerelle",
    badge: "Taxi > VTC",
    price: "600",
    fee: "+162€ frais examen CMA",
    route: "/formation-mobilite-passerelle-taxi-vers-vtc",
    meta: [
      { label: "Volume", value: "5 jours" },
      { label: "Planning", value: "Disponibilités à convenir" },
    ],
    note: {
      title: "Transition",
      text: "Cette passerelle permet de basculer vers l'activité VTC sans repartir sur une formation complète. Vous travaillez les règles, la relation client et les spécificités du métier.",
    },
    highlights: ["Véhicule mis à disposition le jour de l'examen"],
  },
  {
    id: "mobilite-92-75",
    title: "Mobilité",
    badge: "92 / 75",
    price: "449",
    route: "/formation-mobilite-taxi-92",
    meta: [
      { label: "Volume", value: "14h" },
      { label: "Planning", value: "Horaires à convenir" },
    ],
    note: {
      title: "Zone étendue",
      text: "Cette formation permet d'ajouter Paris (75) et les Hauts-de-Seine (92) à votre carte professionnelle taxi pour élargir votre zone d'activité avec un cadre réglementaire clair.",
    },
    highlights: [],
  },
];

const carouselOffers = [
  ...featuredOffers.map((offer) => ({
    ...offer,
    variant: "primary",
  })),
  ...secondaryOffers.map((offer) => ({
    ...offer,
    variant: "light",
  })),
];

export default {
  name: "ServicesTaxi",
  components: {
    CallToContact,
    HomeEnd,
    ServiceFeatureBlock,
    ServicePricingCarousel,
  },
  data() {
    return {
      carouselOffers,
      featureCopy,
    };
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".slide-right", ".slide-left", ".fall");
    });
  },
};
</script>

<style lang="scss" scoped>
.formation {
  & h2 {
    text-align: center;
    background-color: $color-primary;
    color: $color-secondary;
    padding: 10px;
  }
  & .argument {
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    font-size: 1.3em;
  }
  .pricing-carousel {
    width: min(100%, 1180px);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  }

  .pricing-tile {
    width: 100%;
    min-height: 100%;
    padding: clamp(22px, 2vw, 30px);
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: #ffffff;
    box-shadow: 0 10px 24px rgba(0, 42, 84, 0.08);
  }

  .pricing-tile--primary {
    background: $color-primary;
    box-shadow: 0 14px 28px rgba(0, 42, 84, 0.16),
      inset 0 1px 0 rgba(245, 236, 236, 0.06);
  }

  .pricing-tile--light {
    background: $color-secondary;
    box-shadow: 0 12px 24px rgba(0, 42, 84, 0.12),
      inset 0 1px 0 rgba(255, 255, 255, 0.4);
  }

  .pricing-carousel__stage {
    display: grid;
    grid-template-columns: 1fr;
    padding: 18px clamp(14px, 7vw, 92px) 12px;
    margin-bottom: 18px;
  }

  .pricing-carousel__card {
    grid-area: 1 / 1;
    width: min(100%, 470px);
    justify-self: center;
    transition: transform 0.48s cubic-bezier(0.22, 1, 0.36, 1),
      opacity 0.32s ease, filter 0.32s ease, box-shadow 0.32s ease;
  }

  .pricing-carousel__card--active {
    opacity: 1;
    transform: translateX(0) scale(1);
    z-index: 3;
    pointer-events: auto;
  }

  .pricing-carousel__card--prev {
    opacity: 0.72;
    transform: translateX(-34%) scale(0.91);
    z-index: 2;
    pointer-events: none;
    filter: saturate(0.92);
  }

  .pricing-carousel__card--next {
    opacity: 0.72;
    transform: translateX(34%) scale(0.91);
    z-index: 2;
    pointer-events: none;
    filter: saturate(0.92);
  }

  .pricing-carousel__card--hidden {
    opacity: 0;
    transform: translateX(0) scale(0.84);
    z-index: 1;
    pointer-events: none;
  }

  .pricing-carousel__controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    margin-top: 0;
  }

  .pricing-carousel__nav {
    width: 50px;
    height: 50px;
    border: 0;
    border-radius: 50%;
    background: $color-primary;
    color: $color-secondary;
    font-size: 1.8rem;
    line-height: 1;
    box-shadow: 0 0 0 1px rgba(0, 42, 84, 0.18), 0 0 20px rgba(0, 42, 84, 0.14);
    transition: transform 0.2s ease, box-shadow 0.2s ease,
      background-color 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 0 0 1px rgba(0, 42, 84, 0.2), 0 0 24px rgba(0, 42, 84, 0.16);
    }
  }

  .pricing-carousel__dots {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .pricing-carousel__dot {
    width: 10px;
    height: 10px;
    border: 0;
    border-radius: 999px;
    background: rgba(0, 42, 84, 0.18);
    transition: width 0.2s ease, background-color 0.2s ease,
      box-shadow 0.2s ease;
  }

  .pricing-carousel__dot--active {
    width: 34px;
    background: $color-secondary;
    box-shadow: 0 0 16px rgba(254, 185, 20, 0.22);
  }

  .pricing-tile__header,
  .pricing-tile__price-box,
  .pricing-tile__meta,
  .pricing-tile__note-wrap,
  .pricing-tile__highlights,
  .pricing-tile__footer {
    width: 100%;
  }

  .pricing-tile__header {
    min-height: 88px;
  }

  .pricing-tile__eyebrow {
    margin: 0 0 10px;
    font-size: 0.74rem;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(0, 42, 84, 0.48);
    text-align: left;
  }

  .pricing-tile__title-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
    gap: 12px;
  }

  .pricing-tile__title {
    margin: 0;
    font-size: clamp(1.36rem, 1.14rem + 0.5vw, 1.7rem);
    line-height: 1.08;
    color: $color-primary;
    text-align: left;
  }

  .pricing-tile__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 34px;
    padding: 6px 12px;
    border-radius: 999px;
    background: $color-secondary;
    color: $color-primary;
    font-size: 0.74rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    box-shadow: 0 0 0 1px rgba(254, 185, 20, 0.24),
      0 0 16px rgba(254, 185, 20, 0.18);
  }

  .pricing-tile__price-box {
    min-height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 16px 18px;
    border-radius: 18px;
  }

  .pricing-tile__price {
    margin: 0;
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    font-size: clamp(2.5rem, 2.1rem + 0.9vw, 3rem);
    line-height: 0.95;
    text-align: left;
    color: $color-primary;

    & span {
      color: $color-secondary;
      font-size: 0.42em;
    }
  }

  .pricing-tile__fee {
    margin: 8px 0 0;
    min-height: 1.42em;
    font-size: 0.9rem;
    line-height: 1.42;
    text-align: left;
    color: rgba(88, 89, 91, 0.88);
  }

  .pricing-tile__fee--placeholder {
    visibility: hidden;
  }

  .pricing-tile__meta {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px;

    & li {
      padding: 0;
      text-align: left;
    }
  }

  .pricing-tile__meta-label {
    display: block;
    margin-bottom: 4px;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(0, 42, 84, 0.5);
  }

  .pricing-tile__meta-value {
    display: block;
    font-size: 0.96rem;
    line-height: 1.35;
    color: $color-text;
  }

  .pricing-tile__highlights {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    gap: 12px;

    & li {
      position: relative;
      padding-left: 18px;
      font-size: 0.98rem;
      line-height: 1.42;
      text-align: left;
      color: $color-text;

      &::before {
        content: "";
        position: absolute;
        top: 0.62rem;
        left: 0;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: $color-secondary;
      }
    }
  }

  .pricing-tile__note-wrap {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
  }

  .pricing-tile__note {
    width: 100%;
    padding: 16px 18px;
    border-radius: 18px;
    background: rgba(0, 0, 0, 0.42);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);
    backdrop-filter: blur(2px);
  }

  .pricing-tile__note-title {
    margin: 0 0 8px;
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    text-align: left;
    color: rgba(255, 255, 255, 0.92);
  }

  .pricing-tile__note-copy {
    margin: 0;
    font-size: 0.95rem;
    line-height: 1.45;
    text-align: left;
    color: $color-text-light;
  }

  .pricing-tile__footer {
    margin-top: auto;
    padding-top: 6px;
  }

  .pricing-tile__link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 54px;
    border-radius: 16px;
    padding: 0 18px;
    background: $color-secondary;
    color: $color-primary;
    font-size: 0.9rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    text-decoration: none;
    transition: transform 0.2s ease, background-color 0.2s ease, color 0.2s ease,
      box-shadow 0.2s ease;
    box-shadow: 0 0 0 1px rgba(254, 185, 20, 0.24),
      0 0 18px rgba(254, 185, 20, 0.2), 0 10px 18px rgba(0, 42, 84, 0.14);

    &:hover {
      transform: translateY(-1px);
      background: darken($color-secondary, 4%);
      color: $color-primary;
      text-decoration: none;
      box-shadow: 0 0 0 1px rgba(254, 185, 20, 0.28),
        0 0 22px rgba(254, 185, 20, 0.24), 0 12px 22px rgba(0, 42, 84, 0.16);
    }
  }

  .pricing-tile--primary {
    .pricing-tile__eyebrow {
      color: rgba(245, 236, 236, 0.72);
    }

    .pricing-tile__title {
      color: $color-text-light;
    }

    .pricing-tile__badge {
      background: $color-secondary;
      color: $color-primary;
    }

    .pricing-tile__price-box {
      background: rgba(245, 236, 236, 0.04);
      box-shadow: inset 0 0 0 1px rgba(245, 236, 236, 0.08);
    }

    .pricing-tile__price {
      color: $color-text-light;
    }

    .pricing-tile__fee {
      color: rgba(245, 236, 236, 0.74);
    }

    .pricing-tile__meta-label {
      color: rgba(245, 236, 236, 0.62);
    }

    .pricing-tile__meta-value,
    .pricing-tile__highlights li {
      color: $color-text-light;
    }
  }

  .pricing-tile--light {
    .pricing-tile__eyebrow {
      color: rgba(0, 42, 84, 0.72);
    }

    .pricing-tile__badge {
      background: $color-primary;
      color: $color-secondary;
      box-shadow: 0 0 0 1px rgba(0, 42, 84, 0.14),
        0 0 16px rgba(0, 42, 84, 0.14);
    }

    .pricing-tile__price-box {
      background: rgba(0, 0, 0, 0.36);
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18),
        inset 0 0 0 1px rgba(0, 0, 0, 0.22);
    }

    .pricing-tile__fee {
      color: rgba(255, 255, 255, 0.74);
    }

    .pricing-tile__title {
      color: #000000;
    }

    .pricing-tile__meta-value {
      color: #000000;
    }

    .pricing-tile__price {
      color: $color-text-light;
    }

    .pricing-tile__meta-label {
      color: #000000;
    }

    .pricing-tile__highlights li {
      color: $color-primary;
    }

    .pricing-tile__highlights li::before {
      background: $color-primary;
    }

    .pricing-tile__link {
      background: $color-primary;
      color: $color-secondary;
      box-shadow: 0 0 0 1px rgba(0, 42, 84, 0.16),
        0 0 18px rgba(0, 42, 84, 0.16), 0 10px 18px rgba(0, 42, 84, 0.14);
    }

    .pricing-tile__link:hover {
      background: lighten($color-primary, 4%);
      color: $color-secondary;
      box-shadow: 0 0 0 1px rgba(0, 42, 84, 0.18),
        0 0 22px rgba(0, 42, 84, 0.18), 0 12px 22px rgba(0, 42, 84, 0.16);
    }
  }

  @media screen and (max-width: 767px) {
    .pricing-carousel {
      gap: 16px;
    }

    .pricing-carousel__stage {
      order: 2;
      display: block;
      padding: 0;
      margin-bottom: 0;
      min-height: 0 !important;
    }

    .pricing-tile {
      padding: 20px;
      border-radius: 22px;
      gap: 16px;
    }

    .pricing-carousel__card {
      display: none;
      width: 100%;
      max-width: none;
      transform: none;
      opacity: 1;
      filter: none;
    }

    .pricing-carousel__card--active {
      display: flex;
    }

    .pricing-carousel__card--prev,
    .pricing-carousel__card--next,
    .pricing-carousel__card--hidden {
      display: none;
      opacity: 0;
      transform: none;
    }

    .pricing-carousel__controls {
      order: 1;
      position: static;
      z-index: auto;
      margin-top: 0;
      min-height: 44px;
    }

    .pricing-carousel__nav {
      width: 44px;
      height: 44px;
      font-size: 1.55rem;
    }

    .pricing-tile__header {
      min-height: 0;
    }

    .pricing-tile__meta {
      grid-template-columns: 1fr;
    }

    .pricing-tile__note {
      padding: 14px 16px;
    }
  }
}
.double-block {
  padding: clamp(74px, 9vw, 108px) 20px clamp(92px, 11vw, 126px);

  @media screen and (min-width: 768px) {
    padding-inline: 28px;
  }

  @media screen and (min-width: 992px) {
    padding: clamp(88px, 9vw, 116px) clamp(28px, 4vw, 56px)
      clamp(110px, 10vw, 138px);
  }

  &__title {
    width: min(100%, 1040px);
    padding: 0;
    text-align: center;
    margin: 0 auto 44px;

    & h2 {
      margin: 0;
      font-family: "Spartan", "Arial Black", Arial, sans-serif;
      font-weight: 700;
      color: $color-primary;
      font-size: clamp(1.56rem, 1.18rem + 0.98vw, 2.3rem);
      line-height: 1.02;
      letter-spacing: 0.03em;
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.88),
        0 14px 28px rgba(0, 42, 84, 0.08);
    }

    @media screen and (min-width: 992px) {
      margin-bottom: 56px;
    }
  }

  &__articles {
    width: min(100%, 1180px);
    margin: 0 auto;

    > .hr-d {
      width: 94px;
      height: 4px;
      margin: 34px auto 38px;
      border-radius: 999px;
      background: $color-secondary;
      opacity: 1;
      box-shadow: 0 10px 22px rgba(254, 185, 20, 0.18);

      @media screen and (min-width: 992px) {
        margin: 40px auto 44px;
      }
    }
  }
}

.brand-pseudo {
  display: inline-block;
  margin-bottom: 10px;
  font-family: "adam";
  font-size: 0.72rem;
  letter-spacing: 0.34em;
  text-transform: uppercase;
  color: $color-secondary;
  text-shadow: none;
}
.slide-right.active {
  @include slide-right(1.2s);
}
.slide-left.active {
  @include slide-left(1.2s);
}
.fall.active {
  @include fall-down(1s);
}
</style>
